import React from 'react'
import { Outlet } from 'react-router-dom'
import Footer from '../Layout/Footer'
import Header from '../Layout/Header'
import HomeBody from './HomeBody'
import Slider from './Slider/Slider'

const Home = (props) => {
  return (
    <>
       <Header />
      {/* <Slider />
      <HomeBody /> */}
       
      <div>
        <Outlet />
      </div>
      <Footer /> 
    </>
  )
}

export default Home